import { memo, useContext, useState, useEffect } from 'react';
import { LoadingOutlined } from '@ant-design/icons'
import { Divider, Form, Grid, Input, Space } from 'antd'
import { LoginContext } from '../index'
import IntlMessages from 'components/Message/IntlMessages'
import ImgNextWhite from "assets/images/logo-next-white.svg"
import ImgNext from "assets/images/logo-next.svg"
import { DeviceUtil } from 'utils/device-util';
import { isFalse } from 'utils/common-util';
import { getRuntimeEnv } from "const";

const NormalLogin = ({ gotoQrLoging }) => {

  const screens = Grid.useBreakpoint()
  const [showNextLogin, setShowNextLogin] = useState(false)
  const { loading, onSubmit } = useContext(LoginContext)

  useEffect(() => {
    setShowNextLogin(DeviceUtil.isNotDesktop() || isFalse(screens.md))
  }, [screens.md])

  function renderLabel(labelId, icon) {
    return (
      <Space>
        <i className={`feather-icon ${icon}`}></i>
        <IntlMessages id={labelId} />
      </Space>
    )
  }

  function renderSignInIcon(loading) {
    return (
      <span className="after-icon">
        {loading ? <LoadingOutlined /> : <i className="feather-icon icon-chevron-right"></i>}
      </span>
    )
  }

  const nextAuth = () => {
    window.open(getRuntimeEnv("REACT_APP_NEXT_AUTH_DEEP_LINK"), "_blank")
  }

  return (
    <div className="content-login-system">
      <small className="py-2">
        {<IntlMessages id="login.tab.normal.hint" />}
      </small>
      <Form name="loginForm"
        layout="vertical" requiredMark={false}
        onFinish={onSubmit}>
        <div className="pt-3">
          <Form.Item
            name="username"
            className="user-box username-box remove-safe-password-field-styled"
            label={renderLabel('login.tab.normal.label.username', 'icon-user')}
            normalize={value => value.trim()}
            rules={[{ required: true, message: <IntlMessages id="validate.username.required" />, }]}>
            <Input data-username />
          </Form.Item>

          <Form.Item
            name="password"
            className="user-box password-box remove-safe-password-field-styled"
            label={renderLabel('login.tab.normal.label.password', 'icon-lock')}
            normalize={value => value.trim()}
            rules={[{ required: true, message: <IntlMessages id="validate.password.required" />, }]}>
            <Input.Password data-password />
          </Form.Item>

          <div className="d-grid py-3 pt-lg-4">
            <button
              data-login-btn
              className="btn button-ktb-main btn-block"
              type="submit"
              disabled={loading}
            >
              {loading
                ? <IntlMessages id="login.tab.normal.label.login.in-process" />
                : <IntlMessages id="login.tab.normal.label.login" />}
              {renderSignInIcon(loading)}
            </button>
          </div>
          {showNextLogin && (
            <>
              <div>
                <Divider><small>หรือ</small></Divider>
              </div>
              <div>
                <div className="d-grid py-3 ">
                  <button
                    data-next-login-btn
                    onClick={nextAuth}
                    className="btn button-ktb-next"
                    type="button"
                    disabled={loading}
                  >
                    <IntlMessages id="login.tab.normal.label.login.alternative" />
                    <img src={ImgNextWhite} className="h-100 ms-1" alt="next logo" />
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </Form>
      {!showNextLogin && (
        <>
          <small className="text-center mt-3">
            <div>
              <IntlMessages id="login.tab.normal.label.create-new-account.1"/>
              <span className="mx-1">
                <img src={ImgNext} style={{"width" : "55px"}} alt="Logo Next" />
              </span>
              <IntlMessages id="login.tab.normal.label.create-new-account.2"/>
            </div>
          </small>
          <div className='login-text text-center'>
            <span onClick={gotoQrLoging}><IntlMessages id="login.desktop.channel.qr" /></span>
          </div>
        </>
      )}
    </div>
  )
}

export default memo(NormalLogin)